var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';

const state  = {
	status_search: 'default', //has value = ['default', 'name', 'address', 'services']
	list_counselors: [],
  pagination: {
    current_page: 1,
    // total_page: 
  },
  keyword: ""
  // search_name_field: '',
  // search_address_field: ''
}

const mutations = {
	set_status(state, status){
		state.status_search = status
	},
	SET_LIST_COUNSELORS(state, data){
    state.list_counselors = data.counselors    
    state.pagination = data.pagination
  },
  set_search_name(state, name){
  	// state.search_name_field = name
  },
  set_search_address(state, address){
  	// state.search_address_field = address
  },
  update_keyword(state, keyword){
    state.keyword = keyword
  }

}

const actions = {
	load_list_counselors({commit}, data) {
		var request_url = "/search/counselor"
    var params = {}
		var status = state.status_search
    commit('update_keyword', data.keyword)
    params['page'] = data.page || 1
		if (status == 'address'){
      params['address'] = state.keyword
		}else if(status == 'name'){
      params['name'] = state.keyword
		}
    else if(status == 'services'){
      params['services'] = state.keyword      
    }
    else if(status == 'university'){
      params['university'] = state.keyword
    }
    else{
			request_url = "/users/get_list_counselors?page=" + data.page
		}
    axios.get(url + request_url,
      {params},
      {
        headers:{
              'Authorization': cookie.get('user-token') || ''
            }
      })
      .then((response) =>{        
        commit('SET_LIST_COUNSELORS', response.data.extra)
      })
  },
}
const getters = {

}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}





// WEBPACK FOOTER //
// ./src/store/modules/vuex_network_counselors.js